import React, { useState } from 'react';
import { Row, Col, Divider } from 'antd';

import { Text, Title } from '@/components/Typography';
import { ReportInformation } from './ReportInformation';
import { Header } from '../../../ReportTemplate/Header';
import { DownloadPDF } from './DownloadPDF';
import { ResultForce } from './ResultForce';
import { Summary } from './Summary';
import { Comment } from './Comment';

import { useBackCompressiveForceEstimationContext } from '../../context';
import { SendReportModal } from '@/components/ui/Modals/SendReportModal';
import { useApplicationContext } from '@/context/v1/Application/context';
import { SendReportButton } from '@/components/ui/Buttons/SendReportButton';
import { SendReportModalProps, Report } from '@/components/ui/Modals/SendReportModal/types';
import { ResultsContainer } from './styles';

export function Result() {
	const [isEditing, setIsEditing] = useState<boolean>(false);

	const { organization, company, isSandbox } = useApplicationContext();
	const { backCompressiveForceEstimationResult, useExistsReport, file_id, isSendReportModalOpen, handleSendReport, handleCloseSendReportModal, handleOpenSendReportModal } = useBackCompressiveForceEstimationContext();

	// eslint-disable-next-line react-hooks/rules-of-hooks
	const { exists } = useExistsReport(isSandbox, file_id, company?.id, organization?.id)

	if (!backCompressiveForceEstimationResult?.id) {
		return (
			<Row justify="center">
				<Col>
					<Text>Oops... Something went wrong!</Text>
				</Col>
			</Row>
		);
	}

	function handleDisableFormEdition(editing: boolean): void {
		setIsEditing(editing);
	}

	function mountSendReportModalProps(): SendReportModalProps {
		const report: Report = {
			id: backCompressiveForceEstimationResult.id || '',
			workstation_name: backCompressiveForceEstimationResult.informations.workstation_name,
			tools_to_show: [],
			action_plans: [],
			files_names: [backCompressiveForceEstimationResult.informations.original_name]
		};
		return {
			isOpen: isSendReportModalOpen,
			onCancel: handleCloseSendReportModal,
			onConfirm: handleSendReport,
			report: report,
			exists: exists
		};
	}

	return (
		<Row justify="center">
			<Col
				span={24}
				style={{ marginBottom: '2rem', padding: '0 1rem', display: 'flex', justifyContent: 'space-between' }}
			>
				<Title level={4}>Result</Title>
				{isSandbox && <SendReportButton onClick={handleOpenSendReportModal} />}
			</Col>
			<Col style={{ padding: '1rem' }}>
				<ResultsContainer>
					<Header title="Back compressive force estimation" />
					<ReportInformation />
					<Divider type="horizontal" />
					<ResultForce />
					<Divider type="horizontal" />
					<Summary />
					<Divider type="horizontal" />
					<Comment onCommentChange={handleDisableFormEdition} disableEditComment={isEditing} />
					<DownloadPDF onDownloadPDF={handleDisableFormEdition} disableDownload={isEditing} />
				</ResultsContainer>
			</Col>
			{isSandbox && <SendReportModal {...mountSendReportModalProps()} />}
		</Row>
	);
}
